import React from 'react';
export var DeviationViewMode;
(function(DeviationViewMode) {
    DeviationViewMode["Theater"] = 'theater';
    DeviationViewMode["Fullscreen"] = 'fullscreen';
    DeviationViewMode["Normal"] = 'regular';
})(DeviationViewMode || (DeviationViewMode = {}));
export const SessionContext = /*#__PURE__*/ React.createContext({
    isLoggedIn: false
});
SessionContext.displayName = 'SessionContext';
